(() => {
  const isAlreadyInCart = (itemNumber) => {
    itemNumber = `${itemNumber}`;
    const { 0: baseItemNumber } = itemNumber.split('-');

    const cartItems = window.swinger.user.getCartItems();

    return cartItems.find((entry) => `${entry.id}` === baseItemNumber || `${entry.id}` === itemNumber);
  };

  window.swinger.observer.initialize('.swinger-button-purchase[data-itemnumber] button[type="submit"]', (button) => {
    const elem = button.closest('.swinger-button-purchase[data-itemnumber]');
    const itemNumber = elem.getAttribute('data-itemnumber');
    const text = elem.getAttribute('data-text');
    const { 1: number } = `${itemNumber}`.split('-');
    const transactionType = elem.getAttribute('data-transaction-type');
    let regularPrice;
    let regularPriceBuy;
    let regularPriceRent;
    let currentPrice;
    let currentPriceBuy;
    let currentPriceRent;
    let isOutOfStock = false;
    let studioGeoConfig = {};

    Promise.all([
      window.swinger.i18n(),
      window.swinger.api.getItemDetails(itemNumber),
    ])
      .then((results) => {
        const { 0: i18n, 1: resultItem } = results;

        if (!resultItem[0]) {
          return;
        }

        const studioId = resultItem[0].studio ? resultItem[0].studio.id : 0;
        const studioUrl = `${window.swinger.config.apiBase}${window.swinger.config.apiRoutes.contentStudios}?idList[]=${encodeURIComponent(studioId)}`;

        const updateButton = () => {
          const userGeo = window.swinger.user.getGeo();
          const relevantStudioGeo = studioGeoConfig[window.swinger.config.client === 'dvderotik' ? 'dvd' : 'vod'] || {};
          const userGeoIsNotInAllowed = (relevantStudioGeo.allow && relevantStudioGeo.allow.length && relevantStudioGeo.allow.indexOf(userGeo) === -1);
          const userGeoIsDisallowed = (relevantStudioGeo.disallow && relevantStudioGeo.disallow.length && relevantStudioGeo.disallow.indexOf(userGeo) > -1);
          const itemOwnState = window.swinger.user.getItemOwnState(itemNumber);
          const isAlreadyOwned = window.swinger.user.isLoggedIn() && window.swinger.config.productDeliveryType === 'vod' && itemOwnState && itemOwnState.status === 'purchased';
          const isInCart = isAlreadyInCart(itemNumber);
          const isGeoBlocked = userGeoIsNotInAllowed || userGeoIsDisallowed;
          const isHidden = isGeoBlocked || (transactionType === 'rent' && (!currentPriceRent || isOutOfStock || isGeoBlocked || isInCart));
          const notifyMeText = window.swinger.user.getItemNotificationState(itemNumber) ? 'ui.shared.notify-me.on' : 'ui.shared.notify-me.off';
          let updatedText;
          let formattedRegularPrice;
          let formattedCurrentPrice;
          const toBeDisabled = isOutOfStock && window.swinger.user.getItemNotificationState(itemNumber);

          button.disabled = toBeDisabled;
          button[toBeDisabled ? 'setAttribute' : 'removeAttribute']('aria-disabled', 'true');
          button.classList[isOutOfStock ? 'add' : 'remove']('swinger-button-purchase--is-outofstock');
          button[isOutOfStock ? 'setAttribute' : 'removeAttribute']('data-authentication-required', '');
          button[isOutOfStock ? 'setAttribute' : 'removeAttribute']('data-notify-me', i18n(notifyMeText));
          button.classList[isGeoBlocked ? 'add' : 'remove']('swinger-button-purchase--is-geoblocked');
          button.setAttribute('type', isInCart ? 'button' : 'submit');
          elem.classList[isHidden ? 'add' : 'remove']('swinger-button-purchase--is-hidden');

          try {
            const language = window.swinger.config.language;
            const formatOptions = {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            };
            formattedRegularPrice = new Intl.NumberFormat(language, formatOptions).format(regularPrice);
            formattedCurrentPrice = new Intl.NumberFormat(language, formatOptions).format(currentPrice);
          } catch (e) {
            formattedRegularPrice = regularPrice;
            formattedCurrentPrice = currentPrice;
          }

          switch (true) {
            default:
              updatedText = i18n(text, {
                regularPrice: formattedRegularPrice,
                currentPrice: formattedCurrentPrice,
                number,
              });
              break;

            case !!isInCart:
              updatedText = i18n('ui.button-purchase.in-cart');
              break;

            case !!isGeoBlocked:
              updatedText = i18n('ui.button-purchase.geoblocked');
              break;

            case !!isOutOfStock:
              updatedText = i18n('ui.button-purchase.outofstock');
              break;

            case !!isAlreadyOwned:
              updatedText = i18n('ui.button-purchase.purchase-again', {
                regularPrice: formattedRegularPrice,
                currentPrice: formattedCurrentPrice,
                number,
              });
              break;

            case currentPrice !== undefined && !currentPrice:
              updatedText = i18n('ui.button-purchase.cta.free');
              break;
          }

          if (updatedText) {
            updatedText = window.swinger.currency.reformatHTML(updatedText);

            const svgElement = button.querySelector('svg');
            const tempDiv = document.createElement('div');
            tempDiv.innerHTML = window.swinger.md(updatedText);
            const newContent = tempDiv.innerHTML;

            if (svgElement) {
              button.innerHTML = '';
              button.appendChild(svgElement);
              button.insertAdjacentHTML('beforeend', newContent);
            } else {
              button.innerHTML = newContent;
            }
          }
        };

        if (studioId) {
          window.swinger.ajax(studioUrl)
            .then((resultStudio) => {
              studioGeoConfig = (resultStudio[0] && resultStudio[0].geo) || {};
              updateButton();
            })
            .catch(console.info);
        }

        if (
          resultItem[0]
        && resultItem[0].availability !== undefined
        && resultItem[0].availability === 0
        ) {
          isOutOfStock = true;
        }

        if (
          !!resultItem[0].prices
        && !!resultItem[0].prices.self
        && !!resultItem[0].prices.self.buy
        && resultItem[0].prices.self.buy.regularPrice !== undefined
        ) {
          regularPriceBuy = resultItem[0].prices.self.buy.regularPrice;
        }

        if (
          !!resultItem[0].prices
        && !!resultItem[0].prices.self
        && !!resultItem[0].prices.self.buy
        && resultItem[0].prices.self.buy.currentPrice !== undefined
        ) {
          currentPriceBuy = resultItem[0].prices.self.buy.currentPrice;
        }

        if (
          !!resultItem[0].prices
        && !!resultItem[0].prices.self
        && !!resultItem[0].prices.self.rent
        && resultItem[0].prices.self.rent.regularPrice !== undefined
        ) {
          regularPriceRent = resultItem[0].prices.self.rent.regularPrice;
        }

        if (
          !!resultItem[0].prices
        && !!resultItem[0].prices.self
        && !!resultItem[0].prices.self.rent
        && resultItem[0].prices.self.rent.currentPrice !== undefined
        ) {
          currentPriceRent = resultItem[0].prices.self.rent.currentPrice;
        }

        switch (true) {
          default:
            return;

          case transactionType === 'buy':
            regularPrice = regularPriceBuy;
            currentPrice = currentPriceBuy;
            break;

          case transactionType === 'rent':
            regularPrice = regularPriceRent;
            currentPrice = currentPriceRent;
            break;
        }

        document.addEventListener('swinger.user:authchange', updateButton);

        updateButton();
      })
      .catch(console.info);
  }, false);

  document.addEventListener('click', (e) => {
    const elem = window.swinger.eventHub.getTarget(e);

    if (!elem.closest('form[name="button-purchase"] button[type="button"]')) {
      return;
    }

    window.location.href = window.swinger.config.pages.cart;
    e.preventDefault();
  }, true);

  const createSnackbar = (options) => {
    if (
      !window.swinger
      || !window.swinger.snackbar
    ) {
      window.setTimeout(createSnackbar, 300, options);
      return;
    }

    window.swinger.snackbar.create(options);
  };

  document.addEventListener('submit', (e) => {
    const form = window.swinger.eventHub.getTarget(e);

    if (!form.matches('form[name="button-purchase"]')) {
      return;
    }

    let image = form.getAttribute('data-image');

    try {
      image = JSON.parse(image.split('&quot;').join('"'));
    } catch (e) {
      // noop
    }

    const context = {
      itemNumber: form.getAttribute('data-itemnumber'),
      type: form.getAttribute('data-type'),
      name: form.getAttribute('data-name'),
      image,
      transactionType: form.getAttribute('data-transaction-type') || 'buy',
    };

    context.number = 0;
    if (context.itemNumber.indexOf('-') > -1) {
      context.number = context.itemNumber.split('-')[1];
    }

    const apiBase = window.swinger.config.apiBase;
    const cartRoute = `${apiBase}${window.swinger.config.apiRoutes.cart}`;
    const cartItemRoute = `${cartRoute}/item`;
    const body = {
      itemNumber: context.itemNumber,
    };

    if (context.transactionType === 'rent') {
      body.isRental = true;
    }

    window.swinger
      .ajax(`${cartItemRoute}`, {
        method: 'POST',
        body: JSON.stringify(body, null, 4),
      })
      .then((response) => response.json())
      .then(() => {
        window.swinger.user.updateUserData();
        window.swinger.tracking.trackAddToCart(context.itemNumber, context.transactionType);

        window.swinger.$('[type="submit"]', form).forEach((elem) => {
          elem.disabled = false;
        });

        window.swinger.i18n()
          .then((i18n) => {
            createSnackbar({
              isSelfclosing: true,
              children: [
                {
                  component: 'notification',
                  data: {
                    type: 'success',
                    image: context.image,
                    text: i18n(`ui.button-purchase.message.${context.transactionType}.success`, context),
                    button: {
                      href: window.swinger.config.pages.cart,
                      text: i18n('ui.button-purchase.to-cart'),
                    },
                  },
                },
              ],
            });
          })
          .catch(console.info);
      })
      .catch((e) => {
        window.swinger.$('[type="submit"]', form).forEach((elem) => {
          elem.disabled = false;
        });

        window.swinger.i18n()
          .then((i18n) => {
            window.swinger.snackbar.create({
              isSelfclosing: true,
              children: [
                {
                  component: 'notification',
                  data: {
                    type: 'error',
                    text: typeof e === 'string' ? e : i18n('ui.button-purchase.message.error', context),
                  },
                },
              ],
            });
          })
          .catch(console.info);
      });

    e.preventDefault();
  }, true);
})();
